import basicTheme from '../basicTheme.js';
import typography from '../typography.js';

const MuiTableCell = {
    styleOverrides: {
        root: {
            transition: `background-color ${basicTheme.transitions.duration.fast} linear, color ${basicTheme.transitions.duration.fast} linear, border ${basicTheme.transitions.duration.fast} linear`,
            padding: '0',
        },
        head: Object.assign({ color: basicTheme.palette.N30.main, cursor: 'pointer', '&:hover': {
                color: basicTheme.palette.primary.main,
            }, border: 0 }, typography.subtitle2),
    },
};

export { MuiTableCell };
//# sourceMappingURL=MuiTable.js.map
